var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{attrs:{"shadow":"hover"}},[_c('div',{staticClass:"px-1",attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"text-center m-0"},[_vm._v(_vm._s(_vm.cardtitle))])]),_c('PieChart',{staticStyle:{"width":"100%"},attrs:{"data":this.chartdata,"url":''}}),(_vm.loading.chart)?_c('Loader'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }